module.exports = __webpack_public_path__ + "static/media/no_image_profile.b16d68ff.png";